import type { AppContextValues } from "AppContext";
import { AppContext } from "AppContext";
import { useContext } from "react";

export const useAppContext = () => {
  const appContext = useContext(AppContext);

  if (!appContext) {
    throw new Error("useAppContext must be used within an AppContextProvider");
  }

  return appContext;
};

/** Returns app context or null when outside AppContextProvider (e.g. in embeddable widgets). */
export const useAppContextOptional = (): AppContextValues | null =>
  useContext(AppContext);
